// extracted by mini-css-extract-plugin
module.exports = {"container":"MFormFooter_container__1QAWM","button":"MFormFooter_button__1FBer"};